import React, {useContext, useEffect} from 'react'
import t from 'helpers/I18n'

import PropTypes from 'prop-types'
import BaseParagraph from "components/base-components/base-paragraph";
import BaseButton from "components/base-components/base-button";
import StepsLoader from "steps/steps-loader";
import illustration from "components/../assets/svg/group54.svg"
import {AppDataContext} from "../../contexts/app-data";
import { BASE_URL } from '../../env';
import deleteCookie from '../../functions/deleteCookie';



const EndFlow = ({exitStatus}) => {
  const base_URL = `${BASE_URL}/onboarding-entrepreneur-front/v1/step`
  const { state, dispatch } = useContext(AppDataContext)
  const lang = localStorage.getItem('language')

  const fetch_init_options = {
    method: 'POST',
    credentials: 'include',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',            
    }
  }
  const restData = () => {
    fetch(`${base_URL}`, {
      ...fetch_init_options,
      body: JSON.stringify([
        {   "fieldId": 'internal_exit_flag',
          "fieldValue": state.end_flow.exit_statut
        }
      ])
    })
    // dispatch({ type: 'RESET_CONTEXT' })
    // deleteCookie(() => window.location.href = lang === "FR" ? "https://pro.qahellobank.be/fr/public/accueil" : "https://pro.qahellobank.be/nl/public/startpagina")
    
    if (process.env.REACT_APP_ENV === "qa") {
      deleteCookie( () => window.location.href = lang === "FR" ? "https://pro.qahellobank.be/fr/public/accueil" : "https://pro.qahellobank.be/nl/public/startpagina")
    } else if (process.env.REACT_APP_ENV === "prod") {
      deleteCookie( () => window.location.href = lang === "FR" ? "https://pro.hellobank.be/fr/public/accueil" : "https://pro.hellobank.be/nl/public/startpagina")
    } else {
      deleteCookie( () => window.location.href = lang === "FR" ? "https://pro.qahellobank.be/fr/public/accueil" : "https://pro.qahellobank.be/nl/public/startpagina")
    }
  }

  useEffect(() => {
    if (window.PageBus) {
        window.PageBus.publish("analyticsServices", {
            pageID: "cannot open account",
            flowName: "onboarding",
            trackMethod: "pageLoad"
                    }
                );
            }

     }, [])
    // const { state, dispatch } = React.useContext(AppDataContext)
  
  return (
      <div className={"end-flow"}>
        <StepsLoader>
            <BaseParagraph  illustration={illustration} />
            <BaseParagraph align={"center"}>
              <h3>{state.end_flow.title}</h3>
              <p>{state.end_flow.description}</p>
            </BaseParagraph>
            <div className={"footer-action"} style={{bottom: state.footer_height}}>
              <BaseButton caption={t('general.close')} action={restData} link={'/'} />
            </div>
        </StepsLoader>
      </div>

  )
}

EndFlow.propTypes = {
    name: PropTypes.string
}

EndFlow.defaultProps = {
    name: "email-step"
}


export default EndFlow